import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  reviewStage: {
    id: `app.containers.WorkflowEditor.components.ReviewStage.reviewStage`,
    defaultMessage: 'Task Stage',
  },
  markReviewStage: {
    id: `app.containers.WorkflowEditor.components.ReviewStage.markReviewStage`,
    defaultMessage: 'Mark as a task stage',
  },
  tooltip: {
    id: `app.containers.WorkflowEditor.components.ReviewStage.tooltip`,
    defaultMessage:
      'Indicates that applicants in this stage need manual review. This stage will show as a task in the dashboard.',
  },
  taskInstructionsTitle: {
    id: `app.containers.WorkflowEditor.components.ReviewStage.taskInstructionsTitle`,
    defaultMessage: 'Task Instructions',
  },
  taskInstructionsPlaceholder: {
    id: `app.containers.WorkflowEditor.components.ReviewStage.taskInstructionsPlaceholder`,
    defaultMessage: 'Enter instructions...',
  },
});
